import { isEqual } from "lodash";





/**
   * we have to shove the defaults into imageData,
   * else equality check wont work
   */
 export const changesMadeToUnderEditImageData = ({
    imageData, underEditImageData,
     defaultImageSpread
 }) => {
    let fullImageData = {
      imageSpread: defaultImageSpread,
      imageRotate: 0,
      cropX: 0,
      cropY: 0,
      ...imageData,
      caption: undefined //we dont compare changes in caption
    };
    let fullUnderEditImageData = {
      imageSpread: defaultImageSpread,
      imageRotate: 0,
      cropX: 0,
      cropY: 0,
      ...underEditImageData,
      caption: undefined
    };
    return !isEqual(fullImageData, fullUnderEditImageData);
  };